import { Component, OnInit } from '@angular/core';



interface ItemData2 {
  name: string;
  age: string;
  address: string;
}

@Component({
  selector: 'app-manual-punch',
  templateUrl: './manual-punch.component.html',
  styleUrls: ['./manual-punch.component.scss']
})
export class ManualPunchComponent implements OnInit {

  value?: string;
  date = null;
  listOfData2: ItemData2[] = [];


  onChange(result: Date): void {
    console.log('onChange: ', result);
  }
  constructor() { }

  ngOnInit(): void {
    for (let i = 0; i < 100; i++) {
      this.listOfData2.push({
        name: `${i}`,
        age: 'Kalubhai',
        address: 'General'
      });
    }
  }

}
